import React from "react";
import { Alert, List, Badge, Tag, Typography, Button, Space } from "antd";
import { CheckCircleOutlined, FileTextOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { AyudaContextual } from "../../../../components/avisos/AyudaContextual";

const { Text } = Typography;

export const ServiciosRelacionados = ({
  campaniaID,
  form,
  serviciosRelacionados,
  serviciosRegistrados,
  onGenerarOP,
  loadingGenerarOP,
  formNoListo,
  polizarioBloqueado,
}) => {
  return (
    <>
      <div style={{ textAlign: "center", margin: "12px 0" }}>
        <Space size="middle">
          <Badge count={serviciosRegistrados} showZero overflowCount={999}>
            <Tag style={{ padding: "4px 16px", fontSize: 14 }}>
              <FileTextOutlined /> Servicios registrados
            </Tag>
          </Badge>
          {Number(campaniaID) === 59 && (
            <AyudaContextual>
              En caso de tratarse del tercer servicio informa al asegurado que se requiere carta diagnóstico para continuar y escala con supervisor.
            </AyudaContextual>
          )}
        </Space>
      </div>

      {serviciosRelacionados.length ? (
        <List
          size="small"
          bordered
          dataSource={serviciosRelacionados}
          style={{ maxHeight: 320, overflowY: "auto" }}
          renderItem={(item, index) => (
            <List.Item>
              <Text style={{ fontSize: 12 }}>{item}</Text>
            </List.Item>
          )}
        />
      ) : (
        <Space direction="vertical" size="middle" style={{ width: '100%' }}>
          <Alert
            message="Sin servicios previos registrados"
            type="success"
            showIcon
            icon={<CheckCircleOutlined />}
          />
          <Button
            type="primary"
            size="large"
            block
            icon={<PlusCircleOutlined />}
            onClick={onGenerarOP}
            loading={loadingGenerarOP}
            disabled={formNoListo || polizarioBloqueado}
          >
            Generar servicio
          </Button>
        </Space>
      )}
    </>
  );
};
